<template>
  <div class="card border-success my-2">
    <div class="card-body enduser-card-body">
      <h5 class="card-header text-white bg-success">{{ name }}</h5>
      <p class="card-text text-center m-2">
        Schedule status: {{ schedule_status }}
      </p>
      <div
        class="d-flex flex-wrap justify-content-around align-items-center m-2"
      >
        <h6>
          Low-power
          <span class="badge rounded-pill bg-success">{{
            parseInt(stats.hibernating_count)
          }}</span>
        </h6>
        <h6>
          Dry
          <span class="badge rounded-pill bg-secondary">{{
            parseInt(stats.fault_dry_count)
          }}</span>
        </h6>
        <h6>
          Fault
          <span class="badge rounded-pill bg-danger">{{
            parseInt(stats.fault_valve_count) +
            parseInt(stats.fault_awol_count) +
            parseInt(stats.fault_charger_count)
          }}</span>
        </h6>
      </div>
      <h6 class="card-footer text-center mb-0" :class="timestampColor">
        Last updated {{ timestampFmt }}
      </h6>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { timeAgo } from "../../util/textout.js";

export default {
  name: "EnduserCard",

  props: {
    id: String,
    name: String,
    timestamp: String,
    farm_id: String,
  },

  setup(props) {
    const store = useStore();

    const timeStamp = new Date(props.timestamp);

    return {
      stats: computed(
        () =>
          store.getters.farms[props.farm_id].endusers[props.id]?.stats ?? {
            fault_dry_count: 0,
            fault_valve_count: 0,
            fault_awol_count: 0,
            fault_charger_count: 0,
            hibernating_count: 0,
            schedule_active: false,
          }
      ),

      schedule_status: computed(() => {
        const enduser = store.getters.farms[props.farm_id].endusers[props.id];
        if (enduser.schedule_rim_id === null) {
          return "inactive";
        }

        return enduser.schedule_id === enduser.schedule_rim_id &&
          enduser.stats?.schedule_active
          ? "active" + (!enduser.schedule_enabled ? " (disabled)" : "")
          : "updating";
      }),

      timestampFmt: computed(() => timeAgo(timeStamp)),

      timestampColor: computed(() =>
        // show warning background if not contacted within last two hours
        (new Date() - timeStamp) / 60000.0 < 120 ? "bg-light" : "bg-warning"
      ),
    };
  },
};
</script>

<style scoped>
.enduser-card-body {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  padding: 0.5rem;
}

.version-table {
  display: table;
  margin: auto;
  border-spacing: 1rem;
}
</style>
